import { render, staticRenderFns } from "./vehicleTypeCard.vue?vue&type=template&id=00e47d9f&scoped=true&"
import script from "./vehicleTypeCard.vue?vue&type=script&lang=js&"
export * from "./vehicleTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./vehicleTypeCard.vue?vue&type=style&index=0&id=00e47d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e47d9f",
  null
  
)

component.options.__file = "vehicleTypeCard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VIcon,
  VSpacer,
})
